export default "__VITE_ASSET__D6IxmzS5__"